import type { AxiosError } from 'axios'
import type { InsuranceParamsPropertyDto } from 'BrokerTsLib/src/dtos'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'

import { useApp } from '@/hooks/useApp'

import { Container } from '../../../components/Container'
import { Loading } from '../../../components/Loading'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import WizardForbiddenMessage from '../../../components/WizardForbiddenMessage'
import { Step1Form } from '../../../containers/chaloupka/Step1/Step1Form'
import { StepsContent } from '../../../context/StepsContext'
import { useSaveInsuranceParams, useUpdateLastWizardStep } from '../../../hooks/useWizard'
import { useInsuranceParamsContext } from '../../../layouts/Wizard'

export const Step1 = () => {
  const navigate = useNavigate()
  const { product, setProduct } = useApp()

  const { insuranceParams, insuranceParamsId: paramsId, refetchInsuranceParams, error, isLoadingData } = useInsuranceParamsContext()
  const { mutateAsync: updateStep } = useUpdateLastWizardStep()
  const { mutateAsync: saveInsuranceParams } = useSaveInsuranceParams()

  useEffect(() => {
    if (insuranceParams?.generalParams?.insuranceCategoryType)
      setProduct(insuranceParams?.generalParams?.insuranceCategoryType)
  }, [insuranceParams?.generalParams?.insuranceCategoryType])

  const handleSubmit = (values: InsuranceParamsPropertyDto) => {
    const promise = new Promise(function (resolve, reject) {
      saveInsuranceParams(values)
        .then((response) => {
          let promiseChain: Promise<any> = Promise.resolve()
          if ((insuranceParams?.generalParams.lastWizardStep ?? 1) == 1) {
            promiseChain = promiseChain.then(() => { return updateStep({ paramsId: Number(response?.data), step: 2 }) })
          }
          if (paramsId) {
            promiseChain = promiseChain.then(() => { return refetchInsuranceParams() })
          }
          promiseChain.then(() => {
            if (values.nextPage == 'next') {
              navigate(`/chaloupka/wizard/2/${response?.data}`)
            } else {
              navigate(`/chaloupka/wizard/1/${response?.data}`)
            }
          })
          resolve(response)
        })
        .catch((err: AxiosError) => {
          reject(err)
        })
        .finally(() => { })
    })

    return promise
  }

  return (
    <Section>
      <Container>
        {isLoadingData && <Loading large={true} />}
        {(!paramsId || insuranceParams && product == insuranceParams.generalParams.insuranceCategoryType) &&
          <StepsContent step={1}>
            <Steps icon="house" />

            <Step1Form onSubmit={handleSubmit} data={insuranceParams as InsuranceParamsPropertyDto} />
          </StepsContent>
        }

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}
